const FORMSVIEW = {
  nameAcivity: "Nombre/Actividad",
  type: "Tipo",
  group: "Grupo",
  state: "Estado",
  totalQuestion: "Total Preguntas",
  actions: "Acciones",

  versions: "Versiones",
  finish: "Finalizados",
  formType: "Tipo de formulario",
  subForms: "SubFormularios",
  multiForms: "MultiFormularios",
  createdDate: "Fecha de creación",
  updatedDate: "Fecha de actualización",
  currentState: "Estado actual",
  uniqueId: "ID único de formulario",

  copyForm: "Copiar form...",
  lockForm: "Bloquear form",

  tittleEdit: "Editar formulario",
  messageEdit: `Este formulario tiene <strong>{version}</strong> version(es).`,
  messageEdit2: `Favor selecciona una versión de la lista, para proceder a su edición.`,
  version: "Versión:",
  accept: "Aceptar",
  cancel: "Cancelar",

  copyToForm: "Copiar formulario",
  EnterNameToForm: "Ingresa un nombre para el nuevo formulario:",
  copy: "copia",
  selectGorup: "Selecciona el grupo:",

  tittleLockForm: `Cerrar formulario: {activity}`,
  msgLockForm: "Esta acción no se puede deshacer, está seguro?",

  tittleDeleteForm: "Eliminar formulario: {activity}",
  msgDeleteForm: "Ésta opción no se puede deshacer, está seguro que desea eliminar el formulario?",

  notifyClosedForm: {
    tittle: "Cerrar Formularios",
    textSuccess: "El formulario se ha cerrado con éxito",
    textError: `Ocurrio un error, al cerrar el formulario({message})`
  },

  notifyCopyForm: {
    tittleGroup: "Lista de Grupos",
    msgGroup: "Ocurrio un error, al consultar la lista de Grupos {message}",
    tittleCopyForm: "Copiar Formularios",
    msgErrorCopy: "Ocurrio un error, al consultar la informacion del formulario",
    msgSuccessCopy: "La copia del formulario se realizó con éxito",
    msgErrorCopyForm: `Ocurrio un error, al realizar la copia del formulario({message})`
  },

  notifyDeleteForm: {
    title: "Eliminar Formularios",
    success: "El formulario se eliminó con éxito",
    error: "Ocurrio un error, al eliminar el formulario"
  },

  notifyEditForm: {
    tittlemulti: "[MultiForms] Acción no permitida",
    msgMulti: "No existen versiones asociadas a los MultiFormularios. Selecciona un tipo de formulario diferente.",
    tittle: "Editar Formularios",
    msg: "Ocurrio un error, al consultar la informacion del formulario"
  },

  dropdownMenu: {
    update: "Actualizar",
    all: "Todos",
    actives: "Activos",
    deletes: "Eliminados"
  }
};

export default { FORMSVIEW };
